import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useErrorDialog } from "@/shared/components/ErrorDialog";
import { useLogout } from "./api/auth.mutations";
import { authKeys } from "./api/auth.queries";

// Ordering is load-bearing: navigate away FIRST (unmounts the shell + its `me` observer), THEN clear
// the cached session — else a 401 re-fetch flashes.
export function useLogoutFlow() {
  const logout = useLogout();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { showApiError } = useErrorDialog();

  const onLogout = () =>
    logout.mutate(undefined, {
      onSuccess: async () => {
        await navigate({ to: "/login" });
        queryClient.removeQueries({ queryKey: authKeys.me });
      },
      onError: (err) =>
        showApiError(err, { title: "Utloggningen misslyckades" }),
    });

  return { onLogout, isPending: logout.isPending };
}
